// De vragen van 'Template: Intakeformulier FIXtool'. Nodig omdat de template
// tot T13 inline in Intakeforms.jsx stond, met losse titels die nergens aan
// gekoppeld waren. Nu hangt elke vraag over naam, adres, contact en woning aan
// zijn vaste gegeven (FixedFieldKey), zodat het antwoord op de kaart 'Vaste
// gegevens' landt (besluit user 2026-10-28). Titels en antwoordopties komen
// uit het schema, dus een hernoemd label hoeft hier niet mee.
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T13)

import { HOUSEHOLD_FIELDS } from '../adressHelpers/householdFields'

/**
 * @typedef {object} TemplateField
 * @property {string} Title - Vraagtekst
 * @property {string} Type - Vraagsoort in de bouwer
 * @property {'true'|'false'} Required
 * @property {string} [FixedFieldKey] - Vast gegeven waaraan de vraag hangt
 * @property {Array<string>} [Options] - Antwoordopties bij een keuzevraag
 */

/** @type {Array<[string, string, boolean]>} sleutel, vraagsoort, verplicht */
const GEKOPPELD = [
    ['Naam', 'text', true],
    ['Straatnaam', 'text', true],
    ['Huisnummer', 'text', true],
    ['Toevoeging', 'text', false],
    ['Postcode', 'text', true],
    ['Woonplaats', 'text', true],
    ['Telefoon', 'text', true],
    ['Email', 'text', true],
    ['Eigendom', 'multiple-one', true],
    ['AantalBewoners', 'number', false],
    ['Woningvorm', 'multiple-one', false],
    ['Woningcorporatie', 'text', false],
]

/** @returns {Array<TemplateField>} */
const buildFixtoolIntakeTemplate = () => [
    ...GEKOPPELD.map(([key, type, required]) => {
        const def = HOUSEHOLD_FIELDS[key]
        return {
            Title: def.label,
            Type: type,
            Required: required ? 'true' : 'false',
            FixedFieldKey: key,
            ...(def.options ? { Options: def.options.map((o) => o.label) } : {}),
        }
    }),
    { Title: 'Bijzonderheden', Type: 'text', Required: 'false' },
    { Title: 'Notitie', Type: 'notitie', Required: 'false' },
]

export default buildFixtoolIntakeTemplate
